import type {SessionQuestion} from './sessionQuestionSchema';

/**
 * Returns true if the question has been answered (user has selected an answer).
 * Note: Empty string '' is considered answered (used when session is ended early).
 */
export function isSessionQuestionAnswered(question: SessionQuestion): boolean {
  return question.selectedAnswer !== undefined && question.isCorrect !== undefined;
}
